import { Text } from "@chakra-ui/react";
import { KYDVenue } from "@common/interfaces/KYDEvent";

const VenueDisplayHeader = ({ venue }: { venue?: Partial<KYDVenue> }) => {
  if (!venue) return null;

  return (
    <>
      <Text fontSize={"sm"} fontWeight={"medium"}>
        {venue.name}
      </Text>
      <Text fontSize={"sm"} fontWeight={"medium"}>
        <a
          target="_blank"
          rel="noreferrer"
          style={{
            textDecoration: "underline",
          }}
          href={venue.link}
        >
          {venue.address}
        </a>
      </Text>
      <Text fontSize={"xs"} color="gray.400" fontWeight={"medium"}>
        ID: {venue.id}
      </Text>
      {venue.location?.Country === "USA" && !venue.stripe_location_id ? (
        <Text fontSize={"xs"} color="red.400" fontWeight={"medium"}>
          This venue is missing a tax location ID.
          <br />
          Please contact support.
        </Text>
      ) : venue.stripe_location_id ? (
        <Text fontSize={"xs"} color="gray.400" fontWeight={"medium"}>
          Tax location ID: {venue.stripe_location_id}
        </Text>
      ) : null}
    </>
  );
};

export default VenueDisplayHeader;
